// Only these verified, constant backend messages may leave the request boundary.
const rejectionMessages = {
  'clientId已存在': '该接入标识已被使用，请核实已有系统或更换标识。',
  'clientId不能为空': '请填写接入标识。',
  'clientId格式不合法': '接入标识格式不正确，请按填写提示修改。',
  'clientId不能超过128个字符': '接入标识不能超过128个字符。',
  '客户端名称不能为空': '请填写系统名称。',
  '客户端名称不能超过128个字符': '系统名称不能超过128个字符。',
  '客户端不存在': '接入系统不存在，请刷新列表后核实。',
  'Integration Scope不合法': '接入权限不正确，请联系管理员核实。',
  'Integration Scope不能为空': '请明确选择接入权限，或选择不授予权限。',
  '分页参数非法：page必须大于等于1，pageSize范围为1至200': '列表页码或每页条数不正确，请刷新后重试。'
}

export function isIntegrationClientRequest(config) {
  return Boolean(config && config.integrationClientRequest)
}

export function integrationClientError(body, status) {
  const code = body && body.code
  const unauthorized = status === 401 || code === 401
  const forbidden = status === 403 || code === 403
  let message = '操作结果暂无法确认，请先刷新列表，并联系相关负责人核实。刷新无法找回接入密钥，请勿直接重复添加或更换密钥。'
  let kind = 'unknown'
  if (unauthorized || forbidden) {
    kind = 'rejected'
    message = unauthorized ? '登录身份已失效，请重新登录。' : '没有管理接入系统的权限，请联系管理员。'
  } else if (body && typeof body.message === 'string' && Object.prototype.hasOwnProperty.call(rejectionMessages, body.message)) {
    kind = 'rejected'
    message = rejectionMessages[body.message]
  } else if ([400, 404, 405, 409, 422].indexOf(status) !== -1 || code === 404) {
    kind = 'rejected'
    message = '操作被拒绝，请核对接入标识、系统名称和接入权限后再操作。'
  }
  // No axios config, response, headers, arbitrary message or cause is retained.
  return { kind, message, unauthorized, forbidden }
}



// WEBPACK FOOTER //
// ./src/utils/integrationClientRequest.js